import { AppAlert } from '@9b3kuq5phwuk4txw/kiban-react-ui'

/**
 * CloseReasonDialog 内で使用するアラートコンポーネント
 *
 * クローズ理由に関する警告メッセージを表示
 */
export function Alerts() {
  return (
    <AppAlert type='warning'>
      「SQL登録完了」はSalesforceの情報をもとに自動更新されます。
      SQL化する場合は売上情報にオポ管理IDを紐付け、「Open」のままお待ちください。
    </AppAlert>
  )
}
